// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Comment-create {\n  border-radius: 50px;\n  background-color: white;\n  border: 2px solid #b9c0c6;\n  width: 50px;\n  height: 50px;\n  left: -24px;\n  position: absolute;\n  right: 0;\n  pointer-events: all;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.Comment-create:focus {\n  outline: none;\n  border-color: #38a7e8;\n}\n\n.Comment-create::-moz-focus-inner {\n  border: 0;\n}\n", ""]);
// Exports
module.exports = exports;
